import { CS50xemPortugues } from "./flask";

import {
  Reddister,
  ProfileStore,
  ToViewList,
  ReactLibrary,
  HooksReference,
} from "./react";

export const portfolioAll: PortfolioProps = {
  projects: [
    CS50xemPortugues,
    Reddister,
    ProfileStore,
    ToViewList,
    ReactLibrary,
    HooksReference,
  ],
};
